import { palette, shape, typography } from "@src/core/styles";
import styled from "styled-components";
import type {
  AccordionWrapperProps,
  RouteMethodProps,
} from "./route-component.types";

export const RouteComponentWrapper = styled.div`
  width: 360px;
  border-right: ${palette.border.grey};

  @media (max-width: 768px) {
    width: 100%;
    border-right: none;
    border-bottom: ${palette.border.grey};
  }
`;

export const RouteHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 16px;
  border-bottom: ${palette.border.grey};
`;

export const RouteBody = styled.div`
  height: calc(100vh - 118px);
  width: 360px;
  padding-right: 11px;
  overflow: auto;

  @media (max-width: 768px) {
    width: 100%;
    height: auto;
    max-height: 40vh;
  }
`;

export const DefaultText = styled.div`
  ${typography.body_large_regular};
  padding: 12px 24px 12px 16px;
`;

export const AccordionWrapper = styled.div<AccordionWrapperProps>`
  position: relative;
  z-index: ${({ lenght, index }) => lenght - index};
  border: ${({ active }) =>
    active === "true" ? `${palette.border.grey}` : "none"};
  pointer-events: ${({ routeslength }) =>
    routeslength === 0 ? "none" : "auto"};

  & div > .MuiButtonBase-root {
    pointer-events: ${({ routeslength }) =>
      routeslength === 0 ? "none" : "auto"};
  }

  & div > .MuiButtonBase-root.Mui-expanded {
    pointer-events: "auto" !important;
  }

  & .expandIconWrapper > div {
    pointer-events: auto;
  }

  & > .Mui-expanded {
    border: ${({ routeslength, active }) =>
      routeslength === 0 || active === "true"
        ? "none"
        : `${palette.border.grey}`};
    border-left: none;
  }
  & div > .MuiButtonBase-root.MuiAccordionSummary-root.Mui-expanded {
    background-color: ${({ active }) =>
      active === "true"
        ? `${palette.colors.white_main}`
        : "inherit !important"};
    border-top-right-radius: ${shape.rounding.XXL};
    border-bottom-right-radius: ${shape.rounding.XXL};
  }
`;

export const WorkspaceList = styled.div`
  padding: 8px 0;
  & > div {
    background: transparent;
    box-shadow: none;
    & + div > .MuiPaper-root.MuiAccordion-root.Mui-expanded {
      position: relative;
      z-index: 0;
    }
  }
  & > .Mui-expanded {
    margin: 0 !important;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-top-right-radius: ${shape.rounding.XXL};
    border-bottom-right-radius: ${shape.rounding.XXL};
  }

  & .MuiButtonBase-root {
    min-height: 56px;

    position: relative;
    z-index: 0;
    &:hover {
      background-color: rgba(66, 73, 64, 0.08);
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      border-top-right-radius: ${shape.rounding.XXL};
      border-bottom-right-radius: ${shape.rounding.XXL};
    }
    .MuiAccordionSummary-expandIconWrapper.Mui-expanded {
      display: block;
    }
  }
  & > .Mui-expanded > div > .MuiButtonBase-root:hover {
    background-color: inherit !important;
  }
  & > div:hover {
    background-color: rgba(66, 73, 64, 0.08);
    & .MuiPaper-root .MuiAccordion-root:first-of-type {
      border-top-left-radius: ${shape.rounding.XXL};
      border-bottom-left-radius: ${shape.rounding.XXL};
      border-top-right-radius: ${shape.rounding.XXL};
      border-bottom-right-radius: ${shape.rounding.XXL};
    }
  }
  & > .Mui-expanded:hover {
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
    border-top-right-radius: ${shape.rounding.XXL};
    border-bottom-right-radius: ${shape.rounding.XXL};
    background-color: white;
  }
  & .MuiAccordionDetails-root {
    padding: 0;
    & > div {
      &:hover {
        background-color: rgba(66, 73, 64, 0.08);
        &:last-of-type {
          border-bottom-right-radius: ${shape.rounding.XXL};
        }
      }
    }
    & > div:last-child {
      border-bottom-right-radius: ${shape.rounding.XXL};
      overflow: hidden;
    }
    & > div > div {
      padding: 0 16px;
      overflow: hidden;
    }
  }
  & .MuiAccordionSummary-content.Mui-expanded {
    margin: 12px 0;
    & > div {
      ${typography.body_large_medium};
    }
  }
  & .MuiButtonBase-root.Mui-expanded {
    min-height: 56px;
  }
  & .MuiAccordionSummary-expandIconWrapper.Mui-expanded {
    transform: rotate(0deg);
  }
  & > div > .MuiPaper-root.MuiAccordion-root {
    background-color: inherit;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-top-right-radius: ${shape.rounding.XXL};
    border-bottom-right-radius: ${shape.rounding.XXL};
  }
  & > div > .MuiPaper-root.MuiAccordion-root.Mui-expanded {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-top-right-radius: ${shape.rounding.XXL};
    border-bottom-right-radius: ${shape.rounding.XXL};
    position: relative;
    z-index: 999;
  }
  & .MuiButtonBase-root.MuiAccordionSummary-root {
    padding: 0 8px 0 16px;
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
    border-top-right-radius: ${shape.rounding.XXL};
    border-bottom-right-radius: ${shape.rounding.XXL};
  }
`;

export const WorkspaceItemHeader = styled.div`
  text-transform: capitalize;
  ${typography.body_large_regular};
  padding-right: 24px;
`;

export const RoutesGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const RouteItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 64px;
  cursor: pointer;

  & > div {
    display: block;
  }
`;

export const RouteName = styled.div`
  ${typography.body_large_regular};
`;

export const RouteDescription = styled.div`
  ${typography.body_medium_regular};
  color: ${palette.colors.onsurface_variant};
`;

export const RouteMethod = styled.div<RouteMethodProps>`
  text-transform: uppercase;
  ${typography.label_small_medium};
  color: ${({ method }) => {
    switch (method) {
      case "get":
        return `${palette.colors.method.GET}`;
      case "post":
        return `${palette.colors.method.POST}`;
      case "delete":
        return `${palette.colors.method.DELETE}`;
      case "put":
        return `${palette.colors.method.PUT}`;
      case "head":
        return `${palette.colors.method.HEAD}`;
      case "options":
        return `${palette.colors.method.OPTIONS}`;
      case "patch":
        return `${palette.colors.method.PATCH}`;
    }
  }};
`;

export const WorkSpaceName = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const SearchInput = styled.input`
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 14px;
  outline: none;
  background: #f8f9fa;
  transition: border-color 0.2s;

  &:focus {
    border-color: #4caf50;
    background: #fff;
  }

  &::placeholder {
    color: #aaa;
  }
`;

export const SearchWrapper = styled.div`
  padding: 8px 16px;
  border-bottom: 1px solid #e0e0e0;
`;
